import { Platform } from 'react-native';
import { LocalNotification, NotificationChannelEnum } from '@matap/shared';
import { playLocalSound } from '../../utils/play.local.sound';
import { ServiceWorker } from '../../service-workers/service.worker.registration';

export async function triggerLocalNotification(payloadData: LocalNotification) {
  console.log('[local-notification-trigger]', 'triggering', payloadData);

  if (!payloadData || !payloadData.title) return;

  const title = payloadData.title as string;
  const body = (payloadData.body as string) || '';
  const data = { ...payloadData, isLocal: true };

  try {
    if (Platform.OS === 'web') {
      if (payloadData.separateSound) {
        playLocalSound(payloadData.separateSound);
      }
      if (!('Notification' in window) || Notification.permission !== 'granted') return;

      const targetUrl = Platform.OS === 'web' ? window.location.href : '/';

      const notificationOptions = {
        body,
        icon: '/icon-1024.png',
        badge: '/icon-1024-mono.png',
        requireInteraction: payloadData.requireInteraction ?? false,
        data: {
          link: targetUrl,
          ...data,
        },
      };

      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        await ServiceWorker.showLocalNotification(title, notificationOptions);
      } else {
        new Notification(title, notificationOptions);
      }
    } else {
      const Notifications = await import('expo-notifications');
      const notificationId = await Notifications.scheduleNotificationAsync({
        content: { title, body, data, sound: true, color: '#FF231F7C', autoDismiss: true, vibrate: [0, 250, 250, 250] },
        trigger: {
          seconds: 1,
          channelId: (payloadData.channelId as string) || NotificationChannelEnum.DEFAULT,
        },
      });
      setTimeout(async () => {
        try {
          await Notifications.dismissNotificationAsync(notificationId);
        } catch {}
      }, 3600000);
    }
  } catch (e) {
    console.error(e);
  }
}
